module.exports = __webpack_public_path__ + "static/61589914_1350173845133170_299708951128178688_n_optimized-ab6010c515699ade9345a99bd374f95b.jpg";